import { lazy, Suspense } from "react";
import { Helmet } from "react-helmet";

import HeroSection from "./HeroSection";

const OverviewSection = lazy(() => import("./OverviewSection"));
const TeamFeedbackSection = lazy(() => import("./TeamFeedbackSection"));
const BenefitSection = lazy(() => import("./BenefitSection"));
const QualitySection = lazy(() => import("./QualitySection"));
const FeaturesSection = lazy(() => import("./FeaturesSection"));

const Hospitality = () => {
  return (
    <>
      <Helmet>
        <title>
          Next-Level Hospitality Solutions | Employee Feedback & Rating App
        </title>
        <meta
          name="description"
          content="Enhance hospitality operations with LENTERA’s innovative Rating App. Capture anonymous employee feedback, improve teamwork, boost performance and drive continuous growth with real-time, data-driven insights."
        />
        <meta
          name="keywords"
          content="LENTERA hospitality solutions, continuous improvement in hospitality, team performance optimization."
        />
      </Helmet>

      <HeroSection />

      <Suspense fallback={<div className="h-[400px]" />}>
        <OverviewSection />
        <TeamFeedbackSection />
        <BenefitSection />
        <QualitySection />
        <FeaturesSection />
      </Suspense>
    </>
  );
};

export default Hospitality;
